import React, { useState } from 'react';
import { FaWhatsapp, FaEnvelope, FaPaperPlane, FaMapMarkerAlt, FaChevronDown, FaChevronUp, FaExternalLinkAlt } from 'react-icons/fa';
import "./contacto.css";
// Asegúrate de importar tu imagen local
import MapaImagen from './img/mapa-domotic-oficial.png'; // Cambia esta ruta por la correcta

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [showSendOptions, setShowSendOptions] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowSendOptions(true);
  };

  const generateMessage = () => {
    return `Hola Domotic Control,\n\nMi nombre es ${formData.nombre}.\n\n${formData.mensaje}\n\nPueden contactarme al teléfono: ${formData.telefono} o al correo: ${formData.email}\n\nSaludos.`;
  };

  const sendViaWhatsApp = () => {
    const message = encodeURIComponent(generateMessage());
    window.open(`https://wa.me/593992060337?text=${message}`, '_blank');
  };

  const sendViaEmail = () => {
    const subject = encodeURIComponent(`Consulta de ${formData.nombre}`);
    const body = encodeURIComponent(generateMessage());
    window.open(`mailto:info@domoticcontrol.com?subject=${subject}&body=${body}`);
  };

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  // Función para abrir Google Maps
  const openGoogleMaps = () => {
    window.open('https://www.google.com/maps/place/Edificio+Los+Vergeles/@-2.9084099,-79.0016828,15.83z/data=!4m6!3m5!1s0x91cd1900746093e5:0xce5089dba6c50b39!8m2!3d-2.9078283!4d-78.9988094!16s%2Fg%2F11x328ycsf?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D', '_blank');
  };

  return (
    <section id="contacto" className="contact-section">
      <div className="contact-header">
        <h2 className="contact-title">Contáctenos</h2>
        <p className="contact-subtitle">Complete el formulario y elija cómo enviar su consulta</p>
      </div>

      <div className="contact-content-container">
        <div className="contact-left-section">
          {/* Botón para desplegar/ocultar formulario */}
          <button 
            className="toggle-form-button"
            onClick={toggleFormVisibility}
          >
            {isFormVisible ? (
              <>
                <FaChevronUp className="button-icon" />
                OCULTAR FORMULARIO
              </>
            ) : (
              <>
                <FaChevronDown className="button-icon" />
                ENVIAR MENSAJE
              </>
            )}
          </button>

          {isFormVisible && (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="nombre">Empresa / Razón Social</label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Correo electrónico</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="telefono">Teléfono</label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="mensaje">Mensaje / Servicio Requerido</label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleChange}
                  required
                  className="form-textarea"
                  rows="5"
                ></textarea>
              </div>
              
              {!showSendOptions ? (
                <button type="submit" className="submit-button">
                  <FaPaperPlane className="button-icon" />
                  ENVIAR MENSAJE
                </button>
              ) : (
                <div className="send-options">
                  <p className="send-options-title">Seleccione método de envío:</p>
                  <div className="send-buttons">
                    <button 
                      type="button" 
                      className="whatsapp-button"
                      onClick={sendViaWhatsApp}
                    >
                      <FaWhatsapp className="button-icon" />
                      WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </form>
          )}

          <div className="direct-whatsapp-container">
            <button 
              className="direct-whatsapp-button"
              onClick={() => window.open('https://wa.me/593992060337', '_blank')}
            >
              <FaWhatsapp className="button-icon" />
              Contacto directo por WhatsApp
            </button>
          </div>
        </div>

        <div className="map-right-section">
          <div className="map-address">
            <FaMapMarkerAlt className="map-marker-icon" />
            <span>Edificio Los Vergeles, Av. 12 de Abril 2-41, Cuenca.</span>
          </div>
          
          {/* Reemplazo del mapa por imagen clickeable */}
          <div className="map-image-container" onClick={openGoogleMaps}>
            <img 
              src={MapaImagen} 
              alt="Ubicación de Domotic Control en Google Maps" 
              className="map-image"
            />
            <div className="map-overlay">
              <span className="map-overlay-text">
                <FaExternalLinkAlt className="button-icon" />
                Haga clic para ver en Google Maps
              </span>
            </div>
          </div>
          
          <div className="map-note">
            <small>Haga clic en el mapa para abrir la ubicación en Google Maps</small>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;